import React, { createContext, useContext } from 'react';
import { useQuery } from '@apollo/client';
import { emptyArray } from '../../common/utils/assets';
import { HelpTextsGroupQuery } from './graphql';
const HelpTextContext = /*#__PURE__*/createContext({
  loading: false,
  data: [],
  groupName: "",
  refetch: () => {}
});
export const useHelpText = () => useContext(HelpTextContext);

const HelpTextProvider = ({
  groupName,
  children
}) => {
  const request = useQuery(HelpTextsGroupQuery, {
    fetchPolicy: "no-cache",
    variables: {
      where: {
        GroupName: {
          equals: groupName
        }
      }
    }
  });
  const data = request?.data?.HelpTexts?.items || emptyArray;
  return /*#__PURE__*/React.createElement(HelpTextContext.Provider, {
    value: {
      loading: request.loading,
      data,
      groupName,
      refetch: request?.refetch
    }
  }, children);
};

export default HelpTextProvider;